import React from "react";
import { FieldInputNumber } from "../Forms";
import { Field } from "formik";

const HierarchyComponent = ({
  header,
  subHeading,
  fieldName,
  list,
  allocationMethod,
  isEdit,
  isSave,
  handleChange,
  values,
  name,
}) => {
  const sortedList = [...list].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <>
      <div
        className="Fee-section-head addedPlans-card-font"
        style={{ marginBottom: "5px" }}
      >
        {header}
      </div>
      <span className="hierarchy-component-text">
        {sortedList?.length} Records found
      </span>
      <div style={{ width: "45%", marginTop: "10px" }}>
        <div
          className="w-100 justify-content-between disp-flex flex-row"
          style={{ padding: "0px 15px 0px 0px", marginTop: "10px" }}
        >
          <div className="hierarchy-component-text">{subHeading}</div>
          <div className="hierarchy-component-text">Hierarchy</div>
        </div>
        {sortedList?.map((data, index) => {
          var ind =
            allocationMethod == 1
              ? values[fieldName]?.findIndex((x) => x.sourceId == data.sourceId)
              : values[fieldName]?.findIndex(
                  (x) => x.investmentTypeId == data.investmentTypeId
                );
          ind = ind != -1 ? ind : index;
          values[fieldName][ind] = {
            ...values[fieldName][ind],
            [name]:
              allocationMethod == 1 ? data.sourceId : data.investmentTypeId,
          };
          return (
            <div className="w-100 justify-content-between disp-flex flex-row hierarchy-component">
              <div className="mb-0 ft-14 fw-400" style={{ paddingTop: "5px" }}>
                {data.name}
              </div>
              <div>
                <Field
                  size="xxs"
                  isRequired
                  value={values[fieldName][ind].heirarchyNumber}
                  name={`${fieldName}.${ind}.heirarchyNumber`}
                  disabled={isEdit}
                  placeholder=""
                  type="number"
                  onChange={handleChange}
                  autoComplete="off"
                  component={FieldInputNumber}
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default HierarchyComponent;
